import axios, { Axios } from 'axios';

class AppError extends Error {
    constructor({ status, message }: { status?: number; message?: string }){
        super(message);
        this.status = status;
    }
    status?: number;
}

export class HTTPClientConfig{
    baseURL = '';
    accessToken? = '';
}

export class HTTPClient {

    static inject = () => [HTTPClientConfig]
    constructor(config: HTTPClientConfig) {
        this.axios = axios.create({
            baseURL: config.baseURL,
            headers: {
                common: {
                    authorization: `JWT ${config.accessToken || ''}`
                }
            }
        });
    }

    private axios: Axios;

    request = async ({ url, method = 'GET', data, headers = {} }: any) => {
        if (!url) {
            throw new AppError({
                status: 500,
                message: 'url is required'
            });
        }

        let requestBody: any;
        if (data) {
            // would prefer to use `data instanceof FormData` here but in api tests
            // this produces error "FormData is not defined" (even with lib:dom in tsconfig)
            if (typeof data === 'object' && data.toString() === '[object FormData]') {
                requestBody = data;
            } else {
                headers['content-type'] = headers['content-type'] || 'application/json';
                requestBody = JSON.stringify(data);
            }
        }

        const response = await this.axios.request({
            method,
            url,
            headers,
            data: requestBody,
        });

        const body = response.data || {};

        return {
            status: response.status,
            data: body
        };
    };

    delete = (url: string, headers?: any) => this.request({ url, method: 'DELETE', headers });
    patch = (url: string, data?: any, headers?: any) => this.request({ url, method: 'PATCH', data, headers });
    post = (url: string, data?: any, headers?: any) => this.request({ url, method: 'POST', data, headers });
    put = (url: string, data?: any, headers?: any) => this.request({ url, method: 'PUT', data, headers });
    get = (url: string, headers?: any, options?: any) => this.request({ url, method: 'GET', headers, options });
}
